import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { FormSelectOption } from '../../../entities/form-select-option.entity';
import { ShBaseFormComponent } from '../../_core/base-form/base-form.component';
import { ShFormCheckboxListBaseComponent } from '../base-simple/form-checkbox-list-base.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ShFormCheckboxListComplexBaseComponent } from '../base-complex/form-checkbox-list-complex-base.component';
import { NgIf, AsyncPipe } from '@angular/common';
import { ShFormGroupComponent } from '../../_core/form-group/form-group.component';

@Component({
    selector: 'sh-form-checkbox-list',
    templateUrl: './form-checkbox-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ShFormGroupComponent, NgIf, ShFormCheckboxListComplexBaseComponent, ReactiveFormsModule, ShFormCheckboxListBaseComponent, AsyncPipe]
})
export class ShFormCheckboxListComponent extends ShBaseFormComponent {
    @Input() inline = false;
    @Input() options!: FormSelectOption[];
}
